import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import { IPostReferrals, IResponseContactPreference, IResponseGeneric, IResponseReferrals } from './IApi.d'
import { ERROR_500, ERROR_CODE, ERROR_MESSAGE, SUCCESS_200, SUCCESS_201 } from './apiData'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL_UNSEC
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['User-key'] = process.env.REACT_APP_API_USER_KEY_UNSEC

if (process.env.NODE_ENV === 'development') {
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
}

export const SUCCESS_STATUS = [SUCCESS_200, SUCCESS_201];
export const ERROR_STATUS = [ERROR_CODE.code_500, ERROR_CODE.code_501, 
  ERROR_CODE.code_502, ERROR_CODE.code_503, ERROR_CODE.code_504, ERROR_CODE.code_505, 
  ERROR_CODE.code_506, ERROR_CODE.code_507, ERROR_CODE.code_508, 
  ERROR_CODE.code_509, ERROR_CODE.code_510, ERROR_CODE.code_511];


const get = async (uri: string, options?: AxiosRequestConfig<unknown>) => 
    axios.get(uri, options).catch(error => {
      return { status: error.response.status, data: error.message };
    })


const post = async (uri: string, params?: unknown, options?: AxiosRequestConfig<unknown>) => {
  return  axios.post(uri, params, options).catch((reason: AxiosError) => {
    if (reason.response) {
      return { status: reason.response.status ?? ERROR_500, data: reason.response.data ?? ERROR_MESSAGE};
    } else {
      return { status: Number(reason.code ?? ERROR_500), data: reason.message ?? ERROR_MESSAGE};
    }
  }).catch(err => { return { status: err.code || ERROR_500, data: err.message || ERROR_MESSAGE }; })
};


const put = async (uri: string, params?: unknown, options?: AxiosRequestConfig<unknown>) => {
  return axios.put(uri, params, options).catch((reason: AxiosError) => {
    if (reason.response) {
      return { status: reason.response.status ?? ERROR_500, data: reason.response.data ?? ERROR_MESSAGE};
    } else {
      return { status: Number(reason.code ?? ERROR_500), data: reason.message ?? ERROR_MESSAGE};
    }  
  }).catch(err => { return { status: err.code || ERROR_500, data: err.message || ERROR_MESSAGE }; })
};

export const getfetchValidateCuitWithRecaptcha = async (cuit: string, recaptchaToken: string): Promise<IResponseReferrals> => {
  const response: IResponseReferrals = await get(`/referrals/validate-cuit/${cuit}`, {
    headers: { 'x-recaptcha-token': recaptchaToken },
  });
  return response;
}

export const getTermsAndConditionsWithRecaptcha = async (recaptchaToken: string, options?: AxiosRequestConfig<unknown>): Promise<IResponseGeneric> => {
  const newOptions: AxiosRequestConfig<unknown> = {
    ...options,
    responseType: 'blob',
    headers: {
      ...options?.headers,
      'x-recaptcha-token': recaptchaToken,
    },
  }
  const response = await axios.get('/terms-and-conditions', newOptions)
  return { status: response.status, data: response.data }
}

export const fetchReferralshWithRecaptcha = async (data: IPostReferrals, recaptchaToken: string): Promise<IResponseGeneric> => 
 post(`/referrals`, data, { headers: { 'x-recaptcha-token': recaptchaToken } }  
  ).catch(err => { return { status: err.code ?? ERROR_500, data: err.message ?? ERROR_MESSAGE }; });



export const contactPreferenceWithRecaptcha = async (token: string, recaptchaToken: string): Promise<IResponseContactPreference> => 
   put(`/referrals/contact-preference`, null,
    { headers: { token, 'x-recaptcha-token': recaptchaToken } }
  ).then(res => { return {status: Number(res.status), data: res.data}; }
  ).catch(err => { return { status: err.code || ERROR_500, data: err.message || ERROR_MESSAGE }; });


export const newClientRedirect = async (token: string, recaptchaToken: string) => 
   put(`/referrals/sales-opportunity`, null,  { headers: { token, 'x-recaptcha-token': recaptchaToken } })
  
